import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      {/* Noise overlay for premium texture */}
      <div className="noise-overlay" aria-hidden="true" />
    </div>
  );
};
